const data = [
    {
        id: 1,
        name: "Daisie Watts",
        age: 34,
        job: "Fitness Trainer",
        image: "assets/trainer/t3.jpg",
        desc: "Daisie Watts graduated Faculty of Sport at University of Munster. After she graduated, She deals with different sports. She also give many group lessons. She loves her job."
    },
    {   
        id: 2,
        name: "Lucian Rocha",
        age: 28,
        job: "Fitness Trainer",
        image: "assets/trainer/t1.jpg",
        desc: "Lucian Rocha graduated Faculty of Sport at University of Konstanz. After he graduated, he has prepared Mr. Olympia for 3 years.He has silver medal from this competition."
    },
    {   
        id: 3,
        name: "Elena Joseph",
        age: 24,
        job: "Yoga Trainer",
        image: "assets/trainer/t2.jpg",
        desc: "Elena Joseph graduated Faculty of Sport at Norwegian University. She gave many yoga group lessons and she gave seminars to find inner peace in TedX. She has also a youtube channel for yoga."
    },
    {   
        id: 4,
        name: "Wesley Delgado",
        age: 31,
        job: "Fitness Trainer",
        image: "assets/trainer/t4.jpg",
        desc: "Wesley Delgado graduated Faculty of Sport at New York University. He had many of his students compete in bodybuilding competitions.He gave a fit appearance to many of his students. "
    },
    {   
        id: 5,
        name: "Margaret Moreno",
        age: 33,
        job: "Boxing Trainer",
        image: "assets/trainer/t7.jpg",
        desc: "Margaret Moreno graduated Faculty of Sport at University of Michigan. She deals with a lot of fight sports.For example: Box, Kick-Box, Judo, Aikido.She is a boxing trainer for 3 years"
    },
    {   
        id: 6,
        name: "Danny Pace",
        age: 36,
        job: "Kick-Boxing Trainer",
        image: "assets/trainer/t9.jpg",
        desc: "Danny Pace graduated Faculty of Sport at University of Texas.He is the 72kg European Kick-Box Champion in 2018. He has many gold medals in different sport categories."
    },

];

export default data;